import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeatureSection from './components/FeatureSection';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeatureSection />
        <ArticleSection />
        <CTASection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}